var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('p',{staticClass:"decode-result"},[_c('b',[_vm._v(_vm._s(_vm.result))])]),_vm._v(" "),_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d12420","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/devices/new/QRScanner.vue
// module id = null
// module chunks = 